import Validate from '@/components/Validate/Validate.vue';

export default {
	name: 'App',
	components: {
		'validate': Validate,
	},

	created: function() {
		this.$http.interceptors.response.use(undefined, function(err) {
			return new Promise(function(resolve, reject) {
				if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
					this.$store.dispatch('logout');
				}
				throw err;
			});
		});
	}
};